// eslint-disable-next-line import/no-cycle
import bffApi, {BffResponse} from '@client/bffApi';
import {
  GetRtqAdjustedScore,
  InsertQuestionOptions,
  ResetRiskOverrideResponse,
  RiskToleranceService,
  RTQQuestionnaireResponse,
  SaveRiskOverrideResponse,
} from '@simpleinvest/ms-rtq-sdk';
// eslint-disable-next-line import/no-cycle
import {apiKey, getLogger} from '@client/services/sdk';
// eslint-disable-next-line import/no-cycle
import {
  requestInterceptorFulfilledHandler,
  requestInterceptorRejectedHandler,
  responseInterceptorFulfilledHandler,
  responseInterceptorRejectedHandler,
} from '@client/interceptors';
import {AxiosResponse} from 'axios';
import {SourcePlatform} from '@simpleinvest/ms-core-sdk';
import {RiskToleranceResponse} from './response/ServiceResponse';

export default {
  getRiskToleranceServiceInstance(): RiskToleranceService {
    return new RiskToleranceService({
      apiKey,
      sourceInfo: {platform: SourcePlatform.ClientPlatform},
      interceptors: {
        requestInterceptor: requestInterceptorFulfilledHandler,
        requestRejectedInterceptor: requestInterceptorRejectedHandler,
        responseInterceptor: responseInterceptorFulfilledHandler,
        responseRejectedInterceptor: responseInterceptorRejectedHandler,
      },
      logger: getLogger(),
    });
  },

  async retakeRisk(clUserId: string): Promise<RTQQuestionnaireResponse> {
    const service: RiskToleranceService = await this.getRiskToleranceServiceInstance();

    return service.retakeRTQ({clUserId});
  },
  getRtqData(clUserId: string): Promise<AxiosResponse<BffResponse<RiskToleranceResponse>>> {
    return bffApi
      .getAxiosInstance()
      .get<BffResponse<RiskToleranceResponse>>(`${bffApi.getBaseUrl(true)}/clients/${clUserId}/risk-tolerance`);
  },
  async getQuestionnaireScore(clUserId: string): Promise<GetRtqAdjustedScore> {
    const service: RiskToleranceService = await this.getRiskToleranceServiceInstance();

    return service.getQuestionnaireScore({clUserId});
  },
  async resetRiskOverride(clUserId: string): Promise<ResetRiskOverrideResponse> {
    const service: RiskToleranceService = await this.getRiskToleranceServiceInstance();

    return service.resetRiskOverride({clUserId});
  },
  async saveQuestionnaireScore(clUserId: string): Promise<GetRtqAdjustedScore> {
    const service: RiskToleranceService = await this.getRiskToleranceServiceInstance();

    return service.saveQuestionnaireScore({clUserId});
  },
  async saveAnswer(options: InsertQuestionOptions): Promise<unknown> {
    const service: RiskToleranceService = await this.getRiskToleranceServiceInstance();

    return service.insertQuestion(options);
  },
  async saveRiskOverride(clUserId: string, score: number): Promise<SaveRiskOverrideResponse> {
    const service: RiskToleranceService = await this.getRiskToleranceServiceInstance();

    return service.saveRiskOverride({clUserId, score});
  },
  async getRTQQuestionnaire(clUserId: string): Promise<RTQQuestionnaireResponse> {
    const service: RiskToleranceService = await this.getRiskToleranceServiceInstance();

    return service.getRTQQuestionnaire({clUserId});
  },
};
